module.exports = __webpack_public_path__ + "static/media/sheild.f5746f0b.png";